import React from "react";
import { Outlet } from "react-router";
import GoBack from "components/GoBack";


function PIndex() {
  return (
    <div className="overflow-y-auto h-screen pb-20 pt-10 px-4">
      <GoBack />

      <Outlet />
    </div>
  );
}

export default PIndex;
